module.exports = __webpack_public_path__ + "static/media/step2.4b9c9add.png";